import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "group" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "py-1" }
const _hoisted_5 = { class: "break-all" }
const _hoisted_6 = { class: "hidden md:table-cell" }
const _hoisted_7 = { class: "hidden sm:table-cell" }
const _hoisted_8 = ["src", "alt", "title"]
const _hoisted_9 = { class: "hidden md:table-cell" }
const _hoisted_10 = {
  key: 0,
  class: "hidden"
}
const _hoisted_11 = { colspan: "5" }
const _hoisted_12 = { class: "flex flex-col items-stretch bg-neutral-50 rounded-sm overflow-hidden md:flex-row" }
const _hoisted_13 = { class: "md:w-1/2" }
const _hoisted_14 = { class: "block m-6 ml-8 mb-4 text-lg font-medium" }
const _hoisted_15 = { class: "w-full mx-6 md:mb-4 border-separate border-spacing-2" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "w-full p-4 md:w-1/2" }
const _hoisted_18 = { key: 1 }

import { computed, PropType } from 'vue';
import Copy from '@/components/micro/CopyComponent.vue';
import {
  A, AAAA, QueryResult, RecordInfo,
} from '@/model/Api';

type IpRecordWithInfo = {
  record: A | AAAA;
} & RecordInfo


export default /*@__PURE__*/_defineComponent({
  __name: 'IpAddresses',
  props: {
  aRecords: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  aaaaRecords: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const processedRecords = computed(() => props.aRecords.response.answer.concat(props.aaaaRecords.response.answer).filter((item) => ['A', 'AAAA'].includes(item.record.recordType)) as Array<IpRecordWithInfo>);

function getIp(record: A | AAAA): string {
  if ('ipv4' in record) return record.ipv4;
  return record.ipv6.slice(1, -1);
}

return (_ctx: any,_cache: any) => {
  return (processedRecords.value.length !== 0)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("colgroup", null, [
          _createElementVNode("col", { class: "min-w-[35px]" }),
          _createElementVNode("col", { class: "w-full sm:w-[60%] md:w-[35%]" }),
          _createElementVNode("col", { class: "w-[10%] hidden md:table-column" }),
          _createElementVNode("col", { class: "w-[40%] hidden md:w-[25%] sm:table-column" }),
          _createElementVNode("col", { class: "w-[30%] hidden md:table-column" })
        ], -1)),
        _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "border-b-2 border-gray-200 text-left" }, [
            _createElementVNode("th", { scope: "col" }),
            _createElementVNode("th", {
              scope: "col",
              class: "py-1.5 font-medium"
            }, "IP address"),
            _createElementVNode("th", {
              scope: "col",
              class: "py-1.5 font-medium hidden md:table-cell"
            }, "Type"),
            _createElementVNode("th", {
              scope: "col",
              class: "py-1.5 font-medium hidden sm:table-cell"
            }, "Hosted by"),
            _createElementVNode("th", {
              scope: "col",
              class: "py-1.5 font-medium hidden md:table-cell"
            }, "Location")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedRecords.value, (record, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("tr", _hoisted_2, [
                (record.ipInfo)
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 0,
                      class: "text-center",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(e => { e.target?.closest('tr').nextSibling.classList.toggle('hidden'); e.target?.closest('tr').querySelector('svg').classList.toggle('rotate-90') }, ["stop"]))
                    }, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("svg", {
                        width: "1em",
                        height: "1em",
                        viewBox: "0 0 16 16",
                        class: "inline",
                        fill: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                        })
                      ], -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_3)),
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("strong", _hoisted_5, _toDisplayString(getIp(record.record)), 1),
                  _createVNode(Copy, {
                    content: getIp(record.record),
                    class: "[visibility:hidden] group-hover:visible"
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("td", _hoisted_6, _toDisplayString(record.record.recordType === 'A' ? 'IPv4' : 'IPv6'), 1),
                _createElementVNode("td", _hoisted_7, [
                  (record.ipInfo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "inline w-4 h-4 mb-0.5 mr-1.5",
                        src: `https://icons.duckduckgo.com/ip3/${record.ipInfo.asdomain}.ico`,
                        alt: `Hosted by ${record.ipInfo.asname}`,
                        title: `Hosted by ${record.ipInfo.asname}`
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(record.ipInfo?.asname), 1)
                ]),
                _createElementVNode("td", _hoisted_9, _toDisplayString(record.ipInfo?.country), 1)
              ]),
              (record.ipInfo)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(record.ipInfo.org), 1),
                          _createElementVNode("table", _hoisted_15, [
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _cache[2] || (_cache[2] = _createElementVNode("th", {
                                  scope: "row",
                                  class: "text-left font-medium"
                                }, "Location", -1)),
                                _createElementVNode("td", null, [
                                  _createElementVNode("a", {
                                    href: `https://www.google.com/maps/search/${record.ipInfo.city}, ${record.ipInfo.regionName}, ${record.ipInfo.country}`,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "text-blue-600 hover:text-blue-800 hover:underline"
                                  }, _toDisplayString(record.ipInfo.city) + ", " + _toDisplayString(record.ipInfo.regionName) + ", " + _toDisplayString(record.ipInfo.country), 9, _hoisted_16)
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[3] || (_cache[3] = _createElementVNode("th", {
                                  scope: "row",
                                  class: "text-left font-medium"
                                }, "AS", -1)),
                                _createElementVNode("td", null, _toDisplayString(record.ipInfo.as), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[4] || (_cache[4] = _createElementVNode("th", {
                                  scope: "row",
                                  class: "text-left font-medium whitespace-nowrap"
                                }, "AS name", -1)),
                                _createElementVNode("td", null, _toDisplayString(record.ipInfo.asname), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", {
                            class: "min-h-[140px] h-full w-full rounded-sm bg-center",
                            style: _normalizeStyle({ backgroundImage: `url(https://stadiamaps.com/static/outdoors?api_key=23fe682b-ac7c-4f2b-83db-39dcf2a8b9ac&center=${record.ipInfo.lat + 2},${record.ipInfo.lon}&zoom=2&markers=${record.ipInfo.lat},${record.ipInfo.lon}&size=1068x534 )` })
                          }, null, 4)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_18, "No IP addresses records found."))
}
}

})